module.exports = "/images/autoxkm-2@2x.png?490c9ee310d8db4d4826d9dff397fcf1";